/*
 * Anchor jumps on the landing page glide instead of teleporting. The fixed nav
 * bar's height is absorbed by `scroll-margin-top` on the sections (landing.css),
 * which also keeps deep links like /#labs clear of it.
 *
 * Shared by the nav and the footer so both close the same way.
 */
export function scrollToSection(href) {
  const section = document.querySelector(href);
  if (!section) return;

  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  section.scrollIntoView({
    behavior: prefersReducedMotion ? "auto" : "smooth",
    block: "start",
  });
}
